import * as React from 'react';
import classnames from 'classnames';

import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./influencer-selector.i18n.json'));

import { TextEntry } from 'types';

type Props = {
  searchQuery: string,
  additionalClasses?: string | null,
  onSearch: (searchQuery: string) => void
};

const InfluencerSelectorSearch = ({ searchQuery, additionalClasses, onSearch }: Props) => {
  const searchClasses = classnames('influencer-selector__search', additionalClasses);

  const handleSearch = (event: React.SyntheticEvent<TextEntry>) => {
    const searchQueryVal = event.currentTarget.value;
    onSearch(searchQueryVal);
  };

  return (
    <div className={searchClasses}>
      <Input
        name="searchQuery"
        value={searchQuery}
        width="responsive"
        placeholder={__t('influencer_selector.search_placeholder')}
        onChange={handleSearch}
      />
    </div>
  );
};

export default InfluencerSelectorSearch;
